import React, { useMemo } from 'react';
import { Card, Input, Select, Text } from 'v3/components';
import { Col, Row } from 'react-bootstrap';
import { usePreLoad } from '../context';

export function VehicleData() {
  const {
    data,
    setData,
    errors,
    vehicleTypesOptions,
    vehicleBodyTypesOptions,
    vehicleImplementTypesOptions,
    loading,
    loadingDuplicate,
  } = usePreLoad();

  const shouldDisplayImplement = useMemo(
    () => data?.vehicleTypes?.some((selected) => selected.qty_plates > 1),
    [data?.vehicleTypes],
  );

  return (
    <Card
      header={
        <Text color="#464E5F" type="header">
          Dados do Veículo
        </Text>
      }
      bodyCardPadding="1rem 3rem"
    >
      <Row className="form">
        <Col md={4} xs={12} className="mb-3">
          <Select
            label="Tipo de Veículo *"
            options={vehicleTypesOptions}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            value={data?.vehicleTypes}
            onChange={value => {
              const hasTractor = value?.some(type => type?.id === 18)

              setData(old => ({
                ...old,
                vehicleTypes: value || [],
                vehicleImplements: hasTractor ? old.vehicleImplements : [],
              }))
            }}
            multiple
            isDisabled={loading || loadingDuplicate}
            error={errors.vehicleTypes}
          />
        </Col>

        <Col md={4} xs={12} className="mb-3">
          <Select
            label="Tipo de carroceria *"
            options={vehicleBodyTypesOptions}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            value={data?.vehicleBodies}
            onChange={value =>
              setData(old => ({ ...old, vehicleBodies: value || [] }))
            }
            multiple
            isDisabled={loading || loadingDuplicate}
            error={errors.vehicleBodies}
          />
        </Col>

        {shouldDisplayImplement && (
          <Col md={4} xs={12} className="mb-3">
            <Select
              label="Tipo de implemento *"
              options={vehicleImplementTypesOptions}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.id}
              value={data?.vehicleImplements}
              onChange={value =>
                setData(old => ({ ...old, vehicleImplements: value || [] }))
              }
              multiple
              isDisabled={loading || loadingDuplicate}
              error={errors.vehicleImplements}
            />
          </Col>
        )}
      </Row>
    </Card>
  );
}
